import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  helperText,
  fullWidth = false,
  className = '',
  ...props
}) => {
  const baseClasses =
    'border border-neutral-300 rounded-lg px-4 py-2.5 text-sm bg-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 hover:border-neutral-400 disabled:bg-neutral-50 disabled:text-neutral-500 disabled:cursor-not-allowed placeholder:text-neutral-400 resize-none';
  const errorClasses = error
    ? 'border-error-500 focus:ring-error-500 focus:border-error-500'
    : '';
  const widthClasses = fullWidth ? 'w-full' : '';

  const classes = [baseClasses, errorClasses, widthClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          {label}
        </label>
      )}
      <textarea className={classes} {...props} />
      {error && <p className="mt-2 text-sm text-error-600">{error}</p>}
      {helperText && !error && (
        <p className="mt-2 text-sm text-neutral-500">{helperText}</p>
      )}
    </div>
  );
};

export default Textarea;
